import { ReactNode } from 'react';
import SimpleBar, { Props } from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import styles from './BaseScrollbar.module.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

type BaseScrollbarProps = Props & {
  children: ReactNode;
  maxHeight?: string;
};

const BaseScrollbar = (props: BaseScrollbarProps) => {
  const { maxHeight = 'auto', ...restProps } = props;
  return (
    <SimpleBar
      style={{ maxHeight, ...props.style }}
      autoHide={false}
      {...restProps}
      className={`${props.className ? props.className : ''} ${cx('base-scrollbar')}`}
    >
      {props.children}
    </SimpleBar>
  );
};

export default BaseScrollbar;
